import { render, staticRenderFns } from "./Syntheses.vue?vue&type=template&id=0f1c4284&"
import script from "./Syntheses.vue?vue&type=script&lang=js&"
export * from "./Syntheses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports